export default __webpack_public_path__ + "static/media/short_active.d3098d1c.svg";